
-->
<style scoped lang="less">
  .floor3-wrapper{
    width: 1200px;
    margin: 0 auto;
    position: relative;
    margin-top: 30px;
    .black{
      margin-top: 60px;
      margin-bottom: 40px;
      p{
        font-size: 20px;
        margin-bottom: 10px;
        color: rgb(102, 102, 102);
      }
    }
    .list{
      padding-bottom: 60px;
      .title{
        color: #ffc001;
        font-size: 16px;
        padding-left: 10px;
        line-height: 30px;
        margin-bottom: 10px;
      }
      .line{
        width: 320px;
        height: 3px;
        background-color: #ffc001;
        position: relative;
        &:before{
          content:'';
          display: block;
          position: absolute;
          left: 0;
          bottom:0;
          width: 1200px;
          height: 1px;
          background: #ccc;
        }
      }
      img{
        margin: 20px;
        width: 323px;
        height: 312px;
        cursor: pointer;
      }
    }
    .tit{
      padding: 20px;
      color: rgb(102, 102, 102);
      .t1{
        margin-bottom: 30px;
      }
      .t2{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .t2_row{
          margin-right: 40px;
          input{
            height: 30px;
            width: 180px;
            border: 0.5px solid  rgba(92,92,92,0.2);
          }
        }
      }
      .t3{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 30px;
        textarea{
          width: 300px;
          height: 120px;
          border: 0.5px solid  rgba(92,92,92,0.2);
          padding: 5px;
        }
      }
      .sub{
        background-color: #ff4d4c;
        width: 240px;
        height: 40px;
        margin: 30px;
        border-radius: 4px;
        text-align: center;
        line-height: 40px;
        color: #fff;
        cursor: pointer;
      }
      .t4{
        margin-top: 40px;
        position: relative;
        margin-bottom: 30px;
        padding-bottom: 20px;
        &:before{
          content:'';
          display: block;
          position: absolute;
          left: 0;
          bottom:0;
          width: 1200px;
          height: 1px;
          background: #ccc;
        }
      }
    }
   
  }
</style>

<template>
  <div class="floor3-wrapper">
    <div class="black">
      <p>联系我们</p>
      <p>地址：浙江省杭州市富阳区银湖街道富闲路756号6楼616室</p>
    </div>
    <div class="list">
      <div class="title">留言板</div>
      <div class="line"></div>
      <div class="tit">
        <div class="t1">发表您的留言：</div>
        <div class="t2">
          <div class="t2_row">
            姓名： <input type="text">
          </div>
          <div class="t2_row">
            邮箱: <input type="text">
          </div>
          <div class="t2_row">
            电话: <input type="text">
          </div>
        </div>
        <div class="t3">
          内容： <textarea v-model="area" placeholder="留言需审核后才会显示"></textarea>
        </div>
        <div class="sub">提交留言</div>
        <div class="t4">留言</div>
        <div class="t5">暂无留言</div>
      </div>
    </div>
    
  </div>
</template>

<script>
 
export default {
  data() {
    return {
      area
    };
  },
  methods: {
    
  }
};
</script>




// WEBPACK FOOTER //
// src/views/t97/block/floor3.vue